import { AGGREGATOR_BASE_URL } from 'src/environments/base-url';

export const freeBetLevelsBulkUploadUrl = (): string => `${AGGREGATOR_BASE_URL}/games/strategies/free-bet-levels/bulk`;
